export var theme = {
    cancelButton: {
        fontSize: '0.8125rem',
        lineHeight: '1.71',
        letterSpacing: '0.3px',
        textTransform: 'none',
        color: 'rgb(138, 141, 147)',
        backgroundColor: 'rgba(138, 141, 147, 0.04)',
        border: '1px solid rgb(138, 141, 147)',
        padding: '0.1875rem 0.8125rem',
        width: '120px',
        height: '31px',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'rgba(138, 141, 147, 0.04)',
            border: '1px solid rgb(138, 141, 147)',
        },
    },
    submit: {
        fontSize: '0.8125rem',
        lineHeight: '1.71',
        letterSpacing: '0.3px',
        textTransform: 'none',
        backgroundColor: 'rgb(145, 85, 253)',
        boxShadow: 'rgb(58 53 65 / 42%) 0px 4px 8px -4px',
        border: '0px',
        padding: '0.1875rem 0.8125rem',
        width: '120px',
        height: '31px',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'rgb(128, 75, 223)',
            boxShadow: 'rgb(58 53 65 / 56%) 0px 6px 18px -8px',
        },
    },
};
